import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-loaders',
  templateUrl: './loaders.component.html',
  styleUrls: ['./loaders.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LoadersComponent implements OnInit {
  @Input("isSkyAcess") isSkyAccess: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
